import { usePreviewPanelsActions, usePreviewPanelsContext } from '@atlassian/preview-panels-api';

import { fg } from '@confluence/feature-gating';
import { useRightSidebarContext } from '@confluence/page-layout-context';
import { useObjectSidebarActions } from '@confluence/object-sidebar-api/entry-points/useObjectSidebar.ts';

export const useClosePreviewPanel = () => {
	const context = usePreviewPanelsContext();
	const { hideObjectSidebar } = useObjectSidebarActions();
	const { close } = usePreviewPanelsActions();
	const { closeAll } = useRightSidebarContext();

	const closeObjectSidebar = () => {
		window.dispatchEvent(new Event('closeGlobalSidebar'));
		if (fg('confluence_frontend_content_wrapper')) {
			hideObjectSidebar();
		}
	};

	const closeOnlyPreviewPanel = (onClose?: () => void): void => {
		if (context?.state?.panel) {
			close(onClose);
		}
	};

	const closeAllPanels = (): void => {
		closeAll();
		closeObjectSidebar();
	};

	return { closeAllPanels, closeOnlyPreviewPanel };
};
